export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOG_OUT = 'LOG_OUT';
export const UPDATE_LOADING = 'UPDATE_LOADING';

export const CREATE_ALERT = 'CREATE_ALERT';
export const CLOSE_ALERT = 'CLOSER_ALERT';